/* eslint-disable prettier/prettier */
import styled from "styled-components"
import { Grid as _Grid } from "@material-ui/core";

export const Nav = styled.nav`
  padding: 8px 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
  background-image: linear-gradient(
    to right,
    ${props => props.theme.color.secondary},
    ${props => props.theme.color.primary}
  );
  box-shadow: 0px 10px 10px rgba(0,0,0,0.4);
  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 0;
    background-image: none;
  }
`

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  
  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 0 16px;
    background-image: linear-gradient(
    to right,
    ${props => props.theme.color.secondary},
    ${props => props.theme.color.primary}
  );
  }
`
export const NavListWrapper = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;

    ${(props: { mobile: boolean }) =>
    props.mobile &&
    `
        flex-direction: column;
        margin-top: 0;

        > ${NavItem} {
          text-align:center;
          padding-top: 0.35em;
          padding-bottom: 0.35em;
          
        }
      `};
  }
`

export const NavItem = styled.li`
  padding: 0 24px;
  ${props => props.theme.fontSize.small};
  letter-spacing: 1px;
  a {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }
  @media (max-width: ${props => props.theme.screen.md}) {
    padding: 0 16px;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
    ${props => props.theme.fontSize.xsmall};
    a {
      ${props => props.theme.fontSize.regular}
    }
    > span {
      width: 100%;
    }
  }
  : last-child{
    padding-right: 48px;
  }

  > span > a {
    text-decoration: none;
    -webkit-text-fill-color: ${props => props.theme.color.link.nav};
    color: ${props => props.theme.color.link.nav};
    
  }
`

export const Brand = styled.div`
  font-family: ${props => props.theme.font.extrabold};
  ${props => props.theme.fontSize.regular};
  color: ${props => props.theme.color.black.regular};
  text-decoration: none;
  letter-spacing: 1px;
  margin: 0;
  padding: 0 24px;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    a {
      color: ${props => props.theme.color.black.regular};
      text-decoration: none;
    }
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 0;
  }
`
export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${props => props.theme.screen.xs}) {
    display: none;
  }

  button {
    ${props => props.theme.fontSize.xsmall};
    color: white;
    background: #098b8c;
    border-radius: 4px;
    padding: 10px 16px;
    text-transform: uppercase;
    font-size: 12px;
  }
`

export const Mobile = styled.div`
  display: none;
  @media (max-width: ${props => props.theme.screen.sm}) {
    display: block;
  }
  ${(props:{hide: boolean, theme: any}) =>
    props.hide &&
    `
    display: block;
    @media (max-width: ${props.theme.screen.sm}) {
      display: none;
    }
  `}
`
export const NavList = styled.ul`
    align-items:center;
`

export const Grid = styled(_Grid)`
    background-image: linear-gradient(
    to right,
    ${props => props.theme.color.secondary},
    ${props => props.theme.color.primary}
  );
  padding: 0 0 16px;
  box-shadow: 0px 5px #000;
`